import { createI18n } from 'vue-i18n'
// import vi from '@/locales/vi.json'
import vi from '@/onenetwork/locales/vi.ts'

export const i18n = createI18n({
  legacy: false, // dùng Composition API
  locale: 'vi', // ngôn ngữ mặc định
  fallbackLocale: 'vi',
  messages: {
    vi,
  },
})
